import React, { useEffect, useMemo, useState } from 'react';
import PageTitle from 'components/common/PageTitle';
import NavItemComponent from 'components/common/NavItemComponent';
import { useSelector } from 'react-redux';
import { Col, Row } from 'react-bootstrap';
import placeholderImage from 'assets/img/placeholder.png';
import Logo from 'assets/img/Logo-Sky.png';
import useMobileScreenSize from 'hooks/useMobileScreenSize';
import { useTranslation } from 'react-i18next';
import Feedback from '../modal/feedback/Feedback';

const Landing = () => {
  const { t } = useTranslation();
  const isMobile = useMobileScreenSize();

  const { new_tree } = useSelector(state => state.appsetting);

  const items = useMemo(
    () =>
      new_tree?.sub_categories
        .filter(
          el =>
            el.name !== 'Carousel Images' &&
            el.name !== 'News' &&
            el.name !== 'Icons'
        )
        .map(el => {
          return {
            ...el,
            title: el.name,
            url:
              el.name === 'Shops'
                ? `/Dashboard/Shops`
                : el.name === 'Mid Mall'
                ? `/Dashboard/Mid Mall`
                : el.name === '3rd Party & Tactical'
                ? `/Dashboard/3rd Party & Tactical`
                : `/${el.name}`,
            icon: el.image01ISfile ?? placeholderImage
          };
        }),
    [new_tree]
  );

  return (
    <>
      <div>
        <PageTitle>
          <div className="flex align-items-center flex-wrap">
            <span>{t('Welcome to the')}</span>
            <img
              src={Logo}
              alt="Sky Toolkit Logo"
              style={{
                marginLeft: '16px',
                width: isMobile ? '180px' : '250px',
                height: isMobile ? '47.7757px' : '57.33px'
              }}
            />
          </div>
        </PageTitle>
        <div className="page-content pt-6 mb-6">
          <Row>
            {items?.map((item, index) => (
              <Col key={index} md="4" className="mb-4">
                <NavItemComponent {...item} className="mb-4 h-100" />
              </Col>
            ))}
          </Row>
        </div>
      </div>
    </>
  );
};

export default Landing;
